<template>
  <div>
    <!-- 筛选条件 -->
    <div class="condition-line">
      <SearchRow @handleFilter="handleFilter">
        <div class="feature-btn order-btn cursor" @click="toFavourite" v-if="quickOrder">
          <i class="iconfont iconzu101" />常用物料快速下单
        </div>
        <div class="feature-btn order-btn cursor" @click="toOrderLess" v-if="orderLess">Non Menu 订单</div>
        <div class="feature-btn upload-btn cursor" @click="toTemplate">
          <i class="iconfont iconzu111" />上传订单模版文件
        </div>
      </SearchRow>
    </div>
    <!-- 商品列表 -->
    <div v-loading="listLoading">
      <div class="item-list">
        <!-- 左侧导航 一级目录 -->
        <div class="card-left" v-if="itemType === 'menu'">
          <div class="item-card" style="width:100%">
            <el-card shadow="none">
              <div
                class="cata-item"
                :class="item.select ? 'active' : ''"
                :style="item.itemStyle"
                v-for="item in showCatalogueList"
                :key="item.key"
                @click="getCatalogue(item)"
              >
                <!-- {{ item.value }}<span class="el-icon-caret-right"></span> -->
                <!-- 二级目录-->
                <el-popover
                  popper-class="sub-popover"
                  placement="right"
                  :close-delay="0"
                  width="300"
                  trigger="hover"
                  @show="subShow(item)"
                  @hide="subHide(item)"
                >
                  <el-card shadow="none">
                    <div
                      class="sub-cata-item"
                      :class="subItem.subSelect ? 'subActive' : ''"
                      v-for="subItem in showSubCataList"
                      :key="subItem.key"
                      @click="getSubCatalogue(item, subItem)"
                    >{{ subItem.value }}</div>
                  </el-card>
                  <p slot="reference">
                    {{ item.value }}
                    <span class="el-icon-caret-right"></span>
                  </p>
                </el-popover>
              </div>
            </el-card>
          </div>
        </div>

        <!-- 右侧商品 -->
        <div class="card-right">
          <div v-if="itemList.length">
            <div class="item-card" v-for="item in itemList" :key="item.itemId">
              <router-link
                :to="{
                  path: `/material/item-detail/${item.itemId}?entityId=${queryParam.entityId}`
                }"
              >
                <el-card shadow="hover" class="cursor">
                  <div class="item-img">
                    <img :src="getImageUrl(item)" />
                  </div>
                  <div class="item-info">
                    <div class="item-price">￥{{ getPrice(item) | thousandSymbol}}</div>
                    <div class="item-name">{{ item.itemName }}</div>
                    <div class="item-time" v-if="item.contractEnd">
                      合同到期时间{{
                      item.contractEnd | parseTime("{y}-{m}-{d}")
                      }}
                    </div>
                  </div>
                  <div class="num-wp">
                    <div class="item-num">
                      <div>
                        <span style="padding-right: 10px">起订:{{ item.factoryMOQ | thousandSymbol }}</span>
                        <!-- 非menu的商品显示 除了印刷品，其他menu的商品都不显示-->
                        <span
                          v-if="
                            !(item.categoryId != 20 && item.isStandard === 1)
                          "
                        >起运:{{ item.factoryMQ | thousandSymbol}}</span>
                        <!-- <span v-if="item.isPreOrder">{{ showQty(item) }}</span> -->
                      </div>
                      <!-- <div v-if="!queryParam.orderCol">DAG:进行中</div> -->
                      <!-- <div v-if="item.soldQty && queryParam.orderCol === 'sold_qty'">已售出:{{item.soldQty | thousandSymbol}}</div> -->
                      <div v-if="queryParam.orderCol === 'quality_score'">质量评分:{{item.qualityScore ? item.qualityScore : '暂无' | formatScore}}</div>
                      <div
                        v-else-if="queryParam.orderCol === 'appearance_score'"
                      >美观评分:{{item.appearanceScore ? item.appearanceScore : '暂无' | formatScore}}</div>
                    </div>
                    <div class="num-under">
                      <span v-if="item.isPreOrder">{{ showQty(item) }}</span>
                    </div>
                  </div>
                </el-card>
              </router-link>
            </div>
          </div>
          <div v-if="!itemList.length && itemType === 'menu'" class="cata-no-data">当前无物料信息</div>
        </div>
      </div>
      <div class="pag-row" v-if="itemList.length">
        <el-pagination
          background
          layout="total, prev, pager, next"
          :current-page="queryParam.page"
          :page-size="queryParam.pageSize"
          :total="total"
          @current-change="handleCurrentChange"
        />
      </div>
      <div v-if="!itemList.length && itemType !== 'menu'" class="no-data">当前无物料信息</div>
    </div>
  </div>
</template>

<script>
import SearchRow from './search-row'
import itemApi from '@/api/item'
import { commonUtils } from '@/utils/common'
import { mapState } from 'vuex'
export default {
  name: 'item-list',
  props: {
    quickOrder: {
      type: Boolean,
      default: true
    },
    orderLess: {
      type: Boolean,
      default: false
    },
    itemType: {
      type: String,
      default: 'menu'
    }
  },
  components: {
    SearchRow
  },
  data () {
    return {
      queryParam: {
        page: 1,
        pageSize: 12,
        isPreOrder: '',
        isStandard: '',
        isPrints: '',
        isMenu: '',
        isNonMenu: '',
        isCampaign: '',
        abiBrandId: '',
        channel: '',
        categoryId: '',
        produceSupplierId: '',
        keyword: '',
        minPrice: '',
        maxPrice: '',
        entityId: '',
        firstCatalogueList: '',
        secondCatalogue: '',
        teamOrderStatus: '',
        factoryMOQ: ''
      },
      nowCataKey: '',
      cataFlag: true,
      subCataFlag: true,
      belongCataKey: '',
      subCataKey: '',
      total: null,
      itemList: [],
      listLoading: false
    }
  },

  computed: {
    ...mapState({
      catalogueList: state => state.base.firstCatalogueMap,
      subCataList: state => state.base.secondCatalogueMap
    }),
    showCatalogueList () {
      return this.catalogueList ? this.setCataList(this.catalogueList) : []
    },
    showSubCataList () {
      let showList = this.subCataList ? this.setSubCataList(this.subCataList) : []

      // 数据处理
      // 当一级不为 CATALOG104 时 不展示 CATALOG106
      if (this.nowCataKey && this.nowCataKey !== 'CATALOG104' && showList.length) {
        let arr = []
        arr = showList.filter(item => {
          return item.key !== 'CATALOG106'
        })
        showList = Object.assign([], arr)
      }

      return showList
    }
  },
  filters: {
    formatScore (value) {
      if (value === Math.round(value)) {
        value = value + '.0'
      }
      return value
    }
  },

  created () {
    this.$store.dispatch('getDictByName', 'firstCatalogueMap')
    this.$store.dispatch('getDictByName', 'secondCatalogueMap')
    this.queryItemList()
  },
  methods: {
    // 展示可用库存相关
    showQty (item) {
      let hint = ''

      if (item.isPreOrder) {
        let availableQty = item.availableQty || 0
        // availableQty = availableQty.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')
        hint =
          availableQty >= 0
            ? `可用库存：${availableQty.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')}`
            : `待生产：${Math.abs(availableQty).toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')}`
      }

      return hint
    },
    // 获取商品列表
    queryItemList () {
      this.listLoading = true
      switch (this.itemType) {
        case 'menu':
          this.queryParam.isMenu = '1'
          break
        case 'printing':
          this.queryParam.isPrints = '1'
          break
        case 'nonMenu':
          this.queryParam.isNonMenu = '1'
          break
        default:
          break
      }
      itemApi
        .queryItemList(this.queryParam)
        .then(res => {
          this.listLoading = false
          if (res.data.resultCode === '0') {
            this.itemList = res.data.resultData.itemList
            this.total = res.data.resultData.pageInfo.totalCounts
          }
        })
        .catch(() => {
          this.listLoading = false
        })
    },
    // 展示二级菜单
    subShow (item) {
      this.nowCataKey = item.key
      item.itemStyle = {
        background: '#ccc'
      }
      if (this.belongCataKey) {
        if (this.showSubCataList) {
          this.showSubCataList.forEach(subItems => {
            // 不属于所属的一级菜单内
            if (item.key !== this.belongCataKey) {
              subItems.subSelect = false
            } else {
              // 属于所属的一级菜单内
              if (subItems.key === this.subCataKey) {
                subItems.subSelect = true
              }
            }
          })
        }
      }
    },
    // 隐藏二级菜单
    subHide (item) {
      item.itemStyle = {
        background: ''
      }
    },
    // 获取一级项目
    getCatalogue (item, isSub) {
      // 单选一级不选二级时，清除原来所选的二级
      if (!isSub) {
        this.subCataKey = ''
        this.belongCataKey = ''
        this.queryParam.secondCatalogue = ''
        this.showSubCataList.forEach(subItem => {
          subItem.subSelect = false
        })
      }

      this.queryParam.firstCatalogueList = ''
      if (this.showCatalogueList) {
        this.showCatalogueList.forEach(items => {
          if (items !== item) {
            items.select = false
          }
        })
      }
      // 先一级，再点二级，应该保留原来的一级
      if (!(isSub && item.select)) {
        item.select = !item.select
      }
      this.queryParam.firstCatalogueList = item.select ? item.key : ''
      this.queryParam.page = 1
      this.queryItemList()
    },

    // 获取二级项目
    getSubCatalogue (item, subItem) {
      this.queryParam.secondCatalogue = ''
      if (this.showSubCataList) {
        this.showSubCataList.forEach(subItems => {
          if (subItems !== subItem) {
            subItems.subSelect = false
          }
        })
      }
      subItem.subSelect = !subItem.subSelect

      this.queryParam.secondCatalogue = subItem.subSelect ? subItem.key : ''
      this.belongCataKey = subItem.subSelect ? item.key : ''
      this.subCataKey = subItem.subSelect ? subItem.key : ''
      this.getCatalogue(item, true)
    },

    // 设置一级商品列表
    setCataList (list) {
      if (this.cataFlag) {
        list.forEach(item => {
          this.$set(item, 'select', false)
          this.$set(item, 'itemStyle', {})
        })
      }
      this.cataFlag = false
      return list
    },
    // 设置二级商品列表
    setSubCataList (list) {
      if (this.subCataFlag) {
        list.forEach(subItem => {
          this.$set(subItem, 'subSelect', false)
        })
      }
      this.subCataFlag = false
      return list
    },

    handleCurrentChange (val) {
      this.queryParam.page = val
      this.queryItemList()
    },

    // 搜索
    handleFilter (value) {
      this.queryParam.page = 1
      this.queryParam.abiBrandId = value.abiBrandId
      this.queryParam.channel = value.channel
      this.queryParam.categoryId = value.categoryId
      this.queryParam.keyword = value.keyword
      this.queryParam.minPrice = value.minPrice
      this.queryParam.maxPrice = value.maxPrice
      this.queryParam.entityId = value.entityId
      this.queryParam.produceSupplierId = value.produceSupplierId
      this.queryParam.isPreOrder = value.isPreOrder
      this.queryParam.teamOrderStatus = value.teamOrderStatus
      this.queryParam.pocmFactoryMOQScope = value.factoryMOQ
      this.queryParam.orderCol = value.orderCol
      this.queryParam.orderMethod = value.orderMethod
      this.queryParam.pocmFactoryMOQBegin = value.pocmFactoryMOQBegin
      this.queryParam.pocmFactoryMOQEnd = value.pocmFactoryMOQEnd
      this.queryParam.isNewItem = value.isNewItem
      this.queryItemList()
    },

    getImageUrl (item) {
      let imageUri = ''
      if (item.imageList && item.imageList.length > 0) {
        imageUri = item.imageList[0].imageFileUri
      }
      return commonUtils.getImageUrl(imageUri)
    },

    // 商品价格
    getPrice (item) {
      // 不含税价
      return item.taxExcludedPrice.toFixed(2)
    },

    // 商品详情
    itemDetail (id) {
      this.$router.push({
        path: `/material/item-detail/${id}`,
        query: {
          entityId: this.queryParam.entityId
        }
      })
    },
    // 快速下单
    toFavourite () {
      this.$emit('toFavourite')
    },
    // 订单模版文件
    toTemplate () {
      this.$emit('toTemplate')
    },
    // 小于五万订单
    toOrderLess () {
      this.$router.push({ name: '' })
    }
  }
}
</script>

<style lang="scss" scoped>
.item-list {
  width: 100%;
  display: flex;
  .card-left {
    width: 25%;
    font-size: 12px;
    .item-card {
      ::v-deep .focusing {
        outline: none !important;
        border: none !important;
      }
      .el-card {
        height: auto;
        min-height: 320px;
        padding: 20px 0;
        .cata-item {
          padding: 0 10px 0 20px;
          height: 35px;
          line-height: 35px;
          cursor: pointer;
          white-space: nowrap;
          overflow: hidden;
          .el-icon-caret-right {
            line-height: 35px;
            float: right;
            color: #fff;
          }
          ::v-deep .el-popover__reference {
            border: none !important;
            padding: 0;
            margin: 0;
          }
        }
        .active,
        .active:hover {
          background: $base-red;
          color: #fff;
        }
      }
    }
  }
  .card-right {
    width: 100%;
    .cata-no-data {
      font-size: 14px;
      color: #888;
      text-align: center;
      margin-top: 170px;
    }
  }

  .item-card {
    width: 25%;
    display: inline-block;
    padding: 10px;
    box-sizing: border-box;
    .el-card {
      width: 100%;
      height: 350px;
      padding-top: 10px;
      .item-img {
        width: 100%;
        height: 160px;
        display: flex;
        justify-content: center;
        align-items: center;
        img {
          max-height: 100%;
          max-width: 100%;
        }
      }
      .item-info {
        height: 130px;
        text-align: center;
        border-bottom: 1px solid #ddd;
        position: relative;
        .item-price {
          color: $base-red;
          font-size: 28px;
          font-weight: bold;
          padding-top: $content-middle;
        }
        .item-name {
          color: #000;
          font-size: 18px;
          font-weight: bold;
          padding: 15px 10px 0 10px;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .item-name:hover {
          color: $base-red;
        }
        .item-time {
          margin-top: 10px;
          position: absolute;
          width: 100%;
          bottom: 0;
        }
        .item-desc {
          color: #666;
          font-size: $font-14;
        }
      }

      // .item-num {
      //   height: 50px;
      //   color: #666;
      //   display: flex;
      //   font-size: $font-12;
      //   align-items: center;
      //   justify-content: space-between;
      //   padding: 0 $content-middle;
      // }

      .num-wp {
        height: 50px;
        color: #666;
        font-size: $font-12;
        padding: 0 $content-middle;
        .item-num {
          height: 50%;
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 7px 0 3px;
        }
      }
    }
  }
}
</style>
